import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link } from "react-router-dom";

const services = [
  {
    id: "web-development",
    title: "Web Development",
    subtitle:
      "Expert Web Development services tailored to your business needs, creating scalable, secure, and high-performing websites and applications.",
    description:
      "Transform your online presence with our expert web development services. From captivating design to seamless development, our skilled team brings your vision to life. Elevate your digital brand today with our tailored solutions.",
    offers: [
      "Responsive Web Design",
      "Custom Web Applications",
      "E-commerce Development",
      "CMS Solutions",
      "Progressive Web Apps (PWA)",
      "Performance Optimization",
      "Web Security & Maintenance",
      "API Integration",
    ],
    link: "/web-development",
  },

  {
    id: "database-migration",
    title: "Database Migration",
    subtitle:
      "Seamless and secure Database Migration services ensuring smooth transition, minimal downtime, and data integrity across platforms.",
    description:
      "Effortlessly migrate your data with our expert solutions, specializing in application, cloud, and data migration. Our database experts ensure a seamless transfer, handling every aspect from planning to execution. Trust us for reliable and tailored database migration, making your journey hassle-free.",
    offers: [
      "Data Assessment & Planning",
      "Cross-Platform Database Migration",
      "Cloud Database Migration",
      "Zero-Downtime Migration",
      "Data Validation & Testing",
      "Backup & Recovery Strategy",
      "Database Modernization",
    ],
    link: "/database-migration",
  },

  {
    id: "bi-analytics",
    title: "AI Solutions",
    subtitle:
      "Unlocking The AI Solutions for Your Business Growth.",
    description:
      "Artificial Intelligence is redefining how businesses operate, think, and grow. It is critical for enterprises to adopt intelligent, data-driven systems that automate repetitive tasks, uncover hidden patterns, and enable faster, smarter decision-making across every function.",
    offers: [
      "AI-Powered Automation",
      "Smart Decision Making",
      "Machine Learning",
      "Intelligent Applications",
      "Automation & Efficiency",
      "Natural Language Processing",
      "Data Analytics",
      "Predictive Insights"
    ],
    link: "/bi-analytics",
  },

  {
    id: "clound-management",
    title: "Cloud Management",
    subtitle:
      "Comprehensive Cloud Management solutions to optimize resources, enhance security, and streamline operations across multi-cloud environments.",
    description:
      "Elevate your business with our AWS and Amazon Cloud Services expertise. Our comprehensive Cloud Managed Services prioritize security, seamless cloud-to-cloud migration, and optimization. Trust us for IaaS, PaaS, and SaaS solutions, ensuring your data and operations thrive in the cloud.",
    offers: [
      "Multi-Cloud Monitoring",
      "Cost Optimization",
      "Cloud Security & Compliance",
      "Automation & Orchestration",
      "Cloud Backup & Recovery",
      "Performance Optimization",
    ],
    link: "/cloud-management",
  },

  {
    id: "cloud-migration",
    title: "Cloud Migration",
    subtitle:
      "Effortless Cloud Migration services that ensure secure, scalable, and cost-effective transition of applications and workloads to the cloud.",
    description:
      "Optimize your cloud migration with our AWS and Amazon Cloud Services expertise. We specialize in seamless transitions, ensuring robust security across IaaS, PaaS, and SaaS solutions. Trust us to navigate complexities, securing your data in the AWS Cloud Computing environment.",
    offers: [
      "Cloud Readiness Assessment",
      "Infrastructure Migration",
      "Application Re-hosting & Re-platforming",
      "Hybrid Cloud Migration",
      "Data Migration",
      "Post-Migration Support",
    ],
    link: "/cloud-migration",
  },

  {
    id: "cloud-consultation",
    title: "Cloud Consultation",
    subtitle:
      "Strategic Cloud Consultation services to help businesses design, implement, and optimize cloud strategies aligned with their goals.",
    description:
      "Elevate your business with Flint's specialized Cloud Consulting. We tailor solutions for optimal AWS and Google Cloud utilization, ensuring secure and seamless integration. Unlock the full potential of cloud computing for growth and efficiency.",
    offers: [
      "Cloud Strategy & Roadmap",
      "Cloud Cost Optimization",
      "Security & Compliance Guidance",
      "Cloud-Native Adoption",
      "Architecture Review",
      "Innovation Workshops",
    ],
    link: "/cloud-consultation",
  },
];

export default function DashboardServices() {
  const [activeTab, setActiveTab] = useState("web-development");

  const activeService = services.find((s) => s.id === activeTab) || services[0];

  return (
    <section className="pt-16 pb-8 md:py-16 px-6 md:px-20 bg-white">
      <h2 className="text-4xl font-bold text-center text-[#0D3559] mb-12 relative">
        Our Services
        <span className="block w-24 h-1 bg-[#0d3559] mx-auto mt-3 rounded-full"></span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* Left Tabs */}
        <div className="flex flex-col space-y-4">
          {services.map((s) => (
            <button
              key={s.id}
              onClick={() => setActiveTab(s.id)}
              className={`px-6 py-3 text-left border rounded-lg font-medium transition ${activeTab === s.id
                ? "border-[#1e4fab] border-2 text-[#0b0550] shadow-lg shadow-[#0b0550]"
                : "border-gray-200 hover:border-gray-400"
                }`}
            >
              {s.title}
            </button>
          ))}
        </div>

        {/* Middle Content */}
        <AnimatePresence mode="wait">
          <motion.div
            key={activeService.id}
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -40 }}
            transition={{ duration: 0.5 }}
            className="md:col-span-2 border rounded-lg p-6 shadow-sm bg-white"
          >
            <h2 className="text-3xl text-[#0D3559] font-bold flex items-center justify-between">
              {activeService.title}{" "}
              <span className="text-xl">
                <Link to={activeService.link}>
                  <FaArrowRightLong />
                </Link>
              </span>
            </h2>
            <p className="mt-3 text-[#0D3559] text-xl font-medium">
              {activeService.subtitle}
            </p>
            <p className="mt-6 text-[#0D3559] text-base font-normal">
              {activeService.description}
            </p>
          </motion.div>
        </AnimatePresence>

        {/* Right What We Offer */}
        <div className="border rounded-lg p-6 shadow-sm bg-white">
          <h4 className="text-lg text-[#0D3559] font-bold mb-4">
            What We Offer
          </h4>
          <ul className="space-y-3">
            {activeService.offers.map((offer, i) => (
              <li key={i} className="flex items-start gap-2">
                <span className="w-2 h-2 rounded-full bg-[#172554] mt-2"></span>
                <span className="text-gray-700">{offer}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
